import { axiosV2 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type GetFolderProps = {
  folderId: string;
  signal?: AbortSignal;
};

export const getFolder = async ({ folderId, signal }: GetFolderProps) => {
  const { data } = await axiosV2.get(`/folders/${folderId}`);

  const decodedData = await decryptResponse(data);

  return decodedData;
};
